import api from './api';

export interface MasterEmail {
    _id?: string;
    id?: string; // Frontend uses id, backend uses _id
    title: string;
    description: string;
    slug: string;
    subject: string;
    content: string;
    fullHtml?: string;
    layoutTitle: string;
    showCTA: boolean;
    buttonConfig?: {
        text: string;
        url: string;
        bgColor: string;
        textColor: string;
        borderRadius: string;
        width: string;
        height: string;
        alignment: string;
        vPosition: number;
        marginTop: string;
        marginBottom: string;
    };
    is_simple_email?: boolean;
    // Trigger configuration:
    //  - 'on_create' : send as soon as a record is created
    //  - 'day'       : send `triggerDays` days after a record is created
    triggerType?: 'on_create' | 'day';
    triggerDays?: number;
}

class MasterEmailService {
    async getAllMasterEmails() {
        const response = await api.get<{ success: boolean; data: MasterEmail[] }>('/master-emails');
        return response.data.data;
    }

    async getMasterEmailById(id: string) {
        const response = await api.get<{ success: boolean; data: MasterEmail }>(`/master-emails/${id}`);
        return response.data.data;
    }

    async createMasterEmail(data: Omit<MasterEmail, '_id' | 'id'>) {
        const response = await api.post<{ success: boolean; data: MasterEmail }>('/master-emails', data);
        return response.data.data;
    }

    async updateMasterEmail(id: string, data: Partial<MasterEmail>) {
        const response = await api.put<{ success: boolean; data: MasterEmail }>(`/master-emails/${id}`, data);
        return response.data.data;
    }

    async deleteMasterEmail(id: string) {
        await api.delete(`/master-emails/${id}`);
    }

    async getVariables() {
        const response = await api.get<{ success: boolean; data: { name: string; value: string }[] }>('/master-emails/variables');
        return response.data.data;
    }

    async sendTestEmail(email: string, subject: string, content: string) {
        const response = await api.post<{ success: boolean; message: string }>('/master-emails/test-email', {
            email,
            subject,
            content,
        });
        return response.data;
    }

    async reorderMasterEmails(orderedIds: string[]) {
        const response = await api.put<{ success: boolean; message: string }>('/master-emails/reorder', { orderedIds });
        return response.data;
    }
}

export default new MasterEmailService();
